import React from 'react';

const DisplayPanel = ({ 
  currentTicket, 
  previousTicket,
  ticketLimits, 
  connectionStatus,
  soundEnabled,
  volume,
  isMobile,
  onToggleSound,
  onVolumeChange
}) => {
  const showAnimation = currentTicket !== previousTicket && previousTicket !== 0;

  return (
    <div className={`display-panel ${isMobile ? 'mobile' : 'desktop'}`}>
      
      {/* Header Section */}
      <header className="panel-header">
        <div className="header-content">
          <h1 className="system-title">Sistema de Turnos</h1>
          <p className="system-subtitle">En Atención</p>
        </div>
        
        <div className="header-controls">
          <button 
            className={`sound-toggle ${soundEnabled ? 'enabled' : 'disabled'}`}
            onClick={onToggleSound}
            aria-label={soundEnabled ? 'Silenciar' : 'Activar sonido'}
          >
            {soundEnabled ? '🔊' : '🔇'}
          </button>
          
          {soundEnabled && (
            <div className="volume-control">
              <input
                type="range"
                min="0"
                max="1"
                step="0.1"
                value={volume}
                onChange={onVolumeChange}
                className="volume-slider"
                aria-label="Volumen"
              />
            </div>
          )}
        </div>
      </header>

      {/* Main Display Section */}
      <main className="display-main">
        <div className={`ticket-display ${showAnimation ? 'changing' : ''}`}>
          
          {showAnimation && (
            <div className="previous-ticket">
              <span className="prev-label">Anterior:</span>
              <span className="prev-number">{previousTicket}</span>
            </div>
          )}

          <div className="current-ticket">
            <div className="ticket-label">Turno Actual</div>
            <div className="ticket-number">{currentTicket}</div>
          </div>

          {showAnimation && (
            <div className="change-animation">
              <div className="animation-circle"></div>
              <div className="animation-pulse"></div>
            </div>
          )}
        </div>
      </main>

      {/* Footer Section */}
      <footer className="panel-footer">
        <div className="footer-grid">
          <div className="status-info">
            <div className={`connection-status ${connectionStatus.includes('Conectado') ? 'connected' : 'disconnected'}`}>
              <span className="status-dot"></span>
              {connectionStatus}
            </div>
          </div>
          
          <div className="limits-info">
            <span className="limits-label">Rango: </span>
            <span className="limits-range">{ticketLimits.min} - {ticketLimits.max}</span>
          </div>
          
          {/*<div className="sound-info">
            <span className="sound-label">Sonido: </span>
            <span className="sound-state">{soundEnabled ? 'ON' : 'OFF'}</span>
          </div>*/}
        </div>
      </footer>

      {/* Mobile Overlay Controls */}
      {/*isMobile && (
        <div className="mobile-controls">
          <button 
            className="mobile-sound-btn"
            onClick={onToggleSound}
          >
            {soundEnabled ? '🔊' : '🔇'}
          </button>
        </div>
      )*/}
    </div>
  );
};

export default DisplayPanel;